import { createApp } from 'vue'

import './scss/main.scss'

window.VueApplication = {}
window.VueApplication.instancesCounter = 0
window.VueApplication.instances = {}
window.VueApplication.events = createApp({})

// noinspection JSUnresolvedVariable
let isIE = !!window.MSInputMethodContext && !!document.documentMode
// noinspection JSDeprecatedSymbols
if (!isIE && document.all) {
  isIE = true
}
if (isIE) {
  const head = document.getElementsByTagName('head')[0]

  let mainScripts = document.createElement('script')
  mainScripts.onload = function () {
    window.svg4everybody()
  }
  mainScripts.setAttribute('src', '/js/ie/svg4everybody.min.js')
  head.appendChild(mainScripts)

  mainScripts = document.createElement('script')
  mainScripts.onload = function () {
    window.svg4everybody()
  }
  mainScripts.setAttribute('src', 'https://cdn.jsdelivr.net/npm/es6-promise@4/dist/es6-promise.auto.js')

  head.appendChild(mainScripts)
}

// noinspection JSUnresolvedFunction
const sharedComponentsContent = require.context(
  './shared',
  true,
  /[A-Z]\w+\.(vue|js)$/
)

const components = {}
sharedComponentsContent.keys().forEach(componentFileName => {
  const componentConfig = sharedComponentsContent(componentFileName)
  const componentName = componentFileName.replace(/^.*\/([^/]+)\.\w+$/, '$1')
  components[componentName] = componentConfig.default || componentConfig
})

/* window.VueApplication.Init = function (element, name, callback, messages) {
  const instanceNumber = window.VueApplication.instancesCounter++
  window.VueApplication.instances[instanceNumber] = new Vue({
    data () {
      return {
        callback,
        messages
      }
    },
    store,
    render: h => h(components[name])
  }).$mount(element)

  return instanceNumber
} */

/**
 * @return {number}
 */
window.VueApplication.Init = function (element, name, callback, messages) {
  const instanceNumber = window.VueApplication.instancesCounter++
  window.VueApplication.instances[instanceNumber] = createApp(components[name], {
    callback,
    messages
  })
  window.VueApplication.instances[instanceNumber].mount(element)

  return instanceNumber
}

/**
 * @return {number}
 */
window.VueApplication.InitByClass = function (className, name, messages) {
  setTimeout(function () {
    const items = document.getElementsByClassName(className)
    for (let i = 0; i < items.length; i++) {
      const item = items[i]
      const holderElement = document.createElement('div')
      item.appendChild(holderElement)
      const instanceNumber = window.VueApplication.instancesCounter++
      window.VueApplication.instances[instanceNumber] = createApp(components[name], {
        messages,
        templateId: item.dataset.templateid,
        path: item.dataset.path
      })
      window.VueApplication.instances[instanceNumber].mount(holderElement)
    }
  }, 200)
  return 1
}

window.VueApplication.Dispose = function (instanceNumber) {
  if (!Object.prototype.hasOwnProperty.call(window.VueApplication.instances, instanceNumber)) {
    return
  }

  const instance = window.VueApplication.instances[instanceNumber]
  if (instance == null) {
    return
  }

  instance.unmount()

  window.VueApplication.instances[instanceNumber] = null
}

window.VueApplication.StartDownload = function (path) {
  const element = document.createElement('a')
  element.setAttribute('href', path)
  element.setAttribute('target', '_blank')
  element.setAttribute('download', '')

  element.style.display = 'none'
  document.body.appendChild(element)

  element.click()

  document.body.removeChild(element)
}

window.VueApplication.LocationReplace = function (path) {
  window.location.replace(path)
}

const checkConnectionInterval = setInterval(function () {
  const elements = document.getElementsByClassName('components-reconnect-rejected')
  if (elements.length === 0) {
    return
  }

  window.location.reload()
  clearInterval(checkConnectionInterval)
}, 100)
